module.exports = __webpack_public_path__ + "static/media/CreateBookListIK.8a711898.png";